import { post } from "../../service/api";

export const CreateNegdiCardPay = async (
  historyId,
  cardId,
  userId,
  pin,
  esukh
) => {
  try {
    const response = await post(`/negdi/pay/withCard`, {
      historyId,
      cardId,
      userId,
      pin,
      esukh,
    });
    if (response && response.data) return response;
    else return null;
  } catch (error) {
    console.error("Error CreateNegdiCardPay:", error);
    return null;
  }
};
